import React, { useEffect, useState } from 'react'
import ReactDom from 'react-dom'
import './Guestbookportal.css'

const MODAL_STYLES = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FFF',
    zIndex: 1999999999, // set to this instead of 999.... because of recaptcha
}

const OVERLAY_STYLES = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#000',
    opacity: 0.5,
    zIndex: 1999999999
}

const CLOSEBTN_STYLES = {
    backgroundColor: 'transparent',
    border: 'none',
    position: 'absolute',
    padding: 0,
    cursor: 'pointer',
    zIndex: 1,
    color: '#707070',
    height: 60,
    margin: '0px 10px'
}

const FLOATING_CLOSEBTN_STYLES = {
    left: -26,
    top: -26,
    color: '#eb5d7b'
}

function Guestbookportal({
    portaltype = 'commonportal',
    open, // 0: closing, 1: opening, others: empty
    children,
    onClose,
    closestyle,
    floatingclose = false,
    floatingclosecolor = '#707070',
    backdropvisible,
    animation,
    floatingdom,
    title,
    bgcolor
}) {
    const [animationstate, setAnimationstate] = useState('') // opening or closing
    const [localopen, setLocalopen] = useState(false)

    useEffect(() => {
        setAnimationstate('opening')
    }, [])

    useEffect(() => {
        if (open === 0) {
            setAnimationstate('closing')
        }
        else if (open === 1) {
            setAnimationstate('opening')
        }
        else {
            setAnimationstate('')
        }
    }, [open])

    useEffect(() => {
        if (animationstate === 'opening') {
            setLocalopen(true)
        }
    }, [animationstate])

    if (open === 0)  { // user want to close it
            return ReactDom.createPortal(
                <div
                    id={`Portalmodal_root`}
                    className={`${backdropvisible ? 'Portalmodal_backdrop' : ''}`}
                >
                    
                    {animationstate === 'closing' && localopen ?
                    <>
                        <div style={OVERLAY_STYLES} />
                        {{
                            'commonportal': <div
                                className={`Guestbookportal_modal Guestportalmodal_${animationstate}`}
                                style={{ ...MODAL_STYLES, backgroundColor: bgcolor }}
                                onAnimationEnd={() => {
                                    setAnimationstate('')
                                    setLocalopen(false)
                                }}
                            >
                                {children}
                            </div>,
                            'userdecide': <div
                                className="Guestbookportal_modal"
                                style={{ ...MODAL_STYLES }}
                            >
                                {children}
                            </div>
                        }[portaltype]}
                        {floatingdom}
                    </>
                    : localopen 
                    ?  <>
                        <div style={OVERLAY_STYLES} />
                        {{
                            'commonportal': <div
                                className={`Guestbookportal_modal Guestportalmodal_${animationstate}`}
                                style={{ ...MODAL_STYLES, backgroundColor: bgcolor }}
                            >
                                {children}
                            </div>,
                            'userdecide': <div
                                className="Guestbookportal_modal"
                                style={{ ...MODAL_STYLES }}
                            >
                                {children}
                            </div>
                        }[portaltype]}
                        {floatingdom}
                    </> 
                    :null
                    }

                </div>,
                document.getElementById('portal')
            )
    }
    else if (open === 1) { // opening it
        return ReactDom.createPortal(
            <div
                id={`Portalmodal_root`}
                className={`${backdropvisible ? 'Portalmodal_backdrop' : ''}`}
            >
              
              {animationstate === 'opening' 
               ?  <>
               <div style={OVERLAY_STYLES} />
                {{
                    'commonportal': <div
                        className={`Guestbookportal_modal Guestportalmodal_${animationstate}`}
                        style={{ ...MODAL_STYLES, backgroundColor: bgcolor }}
                    >
                        {children}
                    </div>,
                    'userdecide': <div
                        className="Guestbookportal_modal"
                        style={{ ...MODAL_STYLES }}
                    >
                        {children}
                    </div>
                }[portaltype]}
                {floatingdom}
                </>
                :!localopen
                 ?  <>
               <div style={OVERLAY_STYLES} />
                {{
                    'commonportal': <div
                        className={`Guestbookportal_modal Guestportalmodal_${animationstate}`}
                        style={{ ...MODAL_STYLES, backgroundColor: bgcolor }}
                    >
                        {children}
                    </div>,
                    'userdecide': <div
                        className="Guestbookportal_modal"
                        style={{ ...MODAL_STYLES }}
                    >
                        {children}
                    </div>
                }[portaltype]}
                {floatingdom}
                </>
                :null}
              
            </div>,
            document.getElementById('portal')
        )
    }
    else {
        return null
    }



}

export default React.memo(Guestbookportal)




// import React, { useEffect, useState } from 'react'
// import ReactDom from 'react-dom'
// import './Guestbookportal.css'

// const MODAL_STYLES = {
//     position: 'fixed',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     backgroundColor: '#FFF',
//     zIndex: 1999999999, // set to this instead of 999.... because of recaptcha
// }

// const OVERLAY_STYLES = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: '#000',
//     opacity: 0.5,
//     zIndex: 1999999999
// }

// const CLOSEBTN_STYLES = {
//     backgroundColor: 'transparent',
//     border: 'none',
//     position: 'absolute',
//     padding: 0,
//     cursor: 'pointer',
//     zIndex: 1,
//     color: '#707070',
//     height: 60,
//     margin: '0px 10px'
// }

// const FLOATING_CLOSEBTN_STYLES = {
//     left: -26,
//     top: -26,
//     color: '#eb5d7b'
// }

// function Guestbookportal({
//     portaltype = 'commonportal',
//     open, // 0: closing, 1: opening, others: empty
//     children,
//     onClose,
//     closestyle,
//     floatingclose = false,
//     floatingclosecolor = '#707070',
//     backdropvisible,
//     animation,
//     floatingdom,
//     title,
//     bgcolor
// }) {
//     const [animationstate, setAnimationstate] = useState('') // opening or closing
//     const [localopen, setLocalopen] = useState(false)

//     useEffect(() => {
//         setAnimationstate('opening')
//     }, [])

//     useEffect(() => {
//         if (open === 0) {
//             setAnimationstate('closing')
//         }
//         else if (open === 1) {
//             setAnimationstate('opening')
//         }
//         else {
//             setAnimationstate('')
//         }
//     }, [open])

//     useEffect(() => {
//         if (animationstate === 'opening') {
//             setLocalopen(true)
//         }
//     }, [animationstate])

//     if (open === 0) { // user want to close it
//         if (animationstate === 'closing' && localopen) {
//             return ReactDom.createPortal(
//                 <div
//                     id={`Portalmodal_root`}
//                     className={`${backdropvisible ? 'Portalmodal_backdrop' : ''}`}
//                 >
//                     <div style={OVERLAY_STYLES} />
//                     {{
//                         'commonportal': <div
//                             className={`Guestbookportal_modal Guestportalmodal_${animationstate}`}
//                             style={{ ...MODAL_STYLES, backgroundColor: bgcolor }}
//                             onAnimationEnd={() => {
//                                 setLocalopen(false)
//                             }}
//                         >
//                             {children}
//                         </div>,
//                         'userdecide': <div
//                             className="Guestbookportal_modal"
//                             style={{ ...MODAL_STYLES }}
//                         >
//                             {children}
//                         </div>
//                     }[portaltype]}
//                     {floatingdom}
//                 </div>,
//                 document.getElementById('portal')
//             )
//         }
//         else {
//             return ReactDom.createPortal(
//                 <div
//                     id={`Portalmodal_root`}
//                     className={`${backdropvisible ? 'Portalmodal_backdrop' : ''}`}
//                 >
//                     {localopen ? <div style={OVERLAY_STYLES} /> : null}
                    
//                 </div>
//                 ,
//                 document.getElementById('portal')
//             )
//         }

//     }
//     else if (open === 1) {
//         return ReactDom.createPortal(
//             <div
//                 id={`Portalmodal_root`}
//                 className={`${backdropvisible ? 'Portalmodal_backdrop' : ''}`}
//             >
//                 <div style={OVERLAY_STYLES} />
//                 {{
//                     'commonportal': <div
//                         className={`Guestbookportal_modal Guestportalmodal_${animationstate}`}
//                         style={{ ...MODAL_STYLES, backgroundColor: bgcolor }}
//                     >
//                         {children}
//                     </div>,
//                     'userdecide': <div
//                         className="Guestbookportal_modal"
//                         style={{ ...MODAL_STYLES }}
//                     >
//                         {children}
//                     </div>
//                 }[portaltype]}
//                 {floatingdom}
//             </div>,
//             document.getElementById('portal')
//         )
//     }
//     else {
//         return null
//     }



// }

// export default React.memo(Guestbookportal)




